<app-header />
<div class="router-content" [class]="'router-content--' + pageBackground()">
  <router-outlet />
</div>
<app-loader />
